// import './js/plugins/lottie.js';
import './js/plugins/slick.min';

// before default
import './layouts/dashboard/layout-dashboard';
import './layouts/quicklists/layout-quicklists';

import './js/default';
import './js/main';

import './modules/evox/menu/module-menu';
import './modules/evox/hero/module-hero';
import './modules/evox/carousel-tabs/module-carousel-tabs';
import './modules/evox/cardslider/module-cardslider';
import './modules/evox/projects/module-projects';
import './modules/evox/team/module-team';
import './modules/evox/accordion/module-accordion';
import './modules/evox/content-tabs/module-content-tabs';
import './modules/evox/contactform/module-contactform';

import './modules/evox/quantitybreaks/module-quantitybreaks';

import './modules/evox/create-password/module-create-password';

import './modules/evox/order-approvals/order-approvals';

// must be last module
import './modules/evox/tabs/module-tabs';

import './layouts/plp/layout-plp';
import './layouts/pdp/layout-pdp';

import './js/slick-init';
